// counter.ts
import * as universe from '../actions/universe.actions';
import { UniverseCompany } from '../models/universe-company.model';

export interface State {
  isFetching: boolean;
  companies: UniverseCompany[];
}

export const initialState: any = {
  isFetching: false,
  companies: []
};

export function reducer(state: State = initialState, action: universe.Actions): State {

  switch (action.type) {

    case universe.FETCH:
      state.isFetching = true;
      return state;

    case universe.FETCH_SUCCESS:
      state.isFetching = false;
      return Object.assign({}
        , state
        , { companies: action.payload });

    case universe.RESET:
      return Object.assign({}, initialState);

    default:
      return state;
  }
}

export const getUniverse = (state: State) => state;



// WEBPACK FOOTER //
// ./src/reducers/universe.reducer.ts